module.exports = __webpack_public_path__ + "static/media/double-chevron-left.b52c3356.svg";